import { createFileRoute } from "@tanstack/react-router";
import AdminPricingSettings from "@/pages/admin/AdminPricingSettings";

export const Route = createFileRoute("/admin/pricing")({ component: AdminPricingSettings });
